module.exports = __webpack_public_path__ + "img/project_e11.48fb5efd.png";